import InterVariable from 'assets/fonts/InterVariable.woff2?url';
import InterItalicVariable from 'assets/fonts/InterVariable-Italic.woff2?url';

export const MuiCssBaseline = {
  styleOverrides: `
        @font-face {
          font-family: 'Inter';
          font-style: normal;
          font-weight: 100 900;
          font-display: swap;
          src: url(${InterVariable}) format('woff2');
        }
        @font-face {
          font-family: 'Inter';
          font-style: italic;
          font-weight: 100 900;
          font-display: swap;
          src: url(${InterItalicVariable}) format('woff2');
        }
      `,
};
